import { createMetaManager } from 'vue-meta';

const metaManager = createMetaManager();

export default metaManager;
